// PACK
import React, { Component }                         from 'react';
import ReactDOM                                     from 'react-dom';
import { BrowserRouter as Router, Switch, Route }   from 'react-router-dom';
//import fire                                         from './components/firebase';
import registerServiceWorker                        from './registerServiceWorker';


// STYLE
import './style.css';


// PAGES
import Dashboard   from './pages/dashboard/dashboard';



class Root extends Component 
{
    
    
    // ***************** ROUTER *****************
    // ***************** ROUTER *****************
    // ***************** ROUTER ***************** 
    render() 
    {
        return(
            <Router>
                <Switch>
                    <Route path="/"        render={(props) => (<Dashboard  {...props}/>)} />
                </Switch>
            </Router>
        );
            
    }
}




// RENDER
ReactDOM.render(<Root />, document.getElementById('root'));

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js